import React, { FC, memo, useState } from 'react';
import clsx from 'clsx';

import ArrowUpIcon from '@smart-tv/components/icons/arrow-up';
import ArrowDownIcon from '@smart-tv/components/icons/arrow-down';
import Button from '@smart-tv/components/button/button';
import Typography from '@smart-tv/components/typography';
import styles from '../favorites.module.scss';

export enum FavoritesEditSelectedChannelsOrderButtonValue {
  Up = 'UP',
  Down = 'DOWN'
}

interface Props {
  disableUp: boolean;
  disableDown: boolean;
  onClick: (direction: FavoritesEditSelectedChannelsOrderButtonValue) => void;
}

export const FavoritesEditSelectedChannelsRowOrderButtons: FC<Props> = (props: Props) => {
  const { disableUp, disableDown, onClick } = props;

  const [buttonFocused, setButtonFocused] = useState<
    FavoritesEditSelectedChannelsOrderButtonValue | undefined
  >();

  return (
    <div className={styles['favorites-edit-root--order']}>
      <div className={styles['favorites-edit-root--order-btn-wrap']}>
        <Button
          className={styles['favorites-edit-root--order-btn']}
          onNavFocus={() => setButtonFocused(FavoritesEditSelectedChannelsOrderButtonValue.Up)}
          onNavBlur={() => setButtonFocused(undefined)}
          onClick={() => onClick(FavoritesEditSelectedChannelsOrderButtonValue.Up)}
          disabled={disableUp}
        >
          <ArrowUpIcon size={36} />
        </Button>
        {buttonFocused === FavoritesEditSelectedChannelsOrderButtonValue.Up && (
          <Typography variant="caption">Flyt op</Typography>
        )}
      </div>

      <div
        className={clsx(
          styles['favorites-edit-root--order-btn-wrap'],
          styles['favorites-edit-root--order-btn-wrap-right']
        )}
      >
        <Button
          className={styles['favorites-edit-root--order-btn']}
          onNavFocus={() => setButtonFocused(FavoritesEditSelectedChannelsOrderButtonValue.Down)}
          onNavBlur={() => setButtonFocused(undefined)}
          onClick={() => onClick(FavoritesEditSelectedChannelsOrderButtonValue.Down)}
          disabled={disableDown}
        >
          <ArrowDownIcon size={36} />
        </Button>
        {buttonFocused === FavoritesEditSelectedChannelsOrderButtonValue.Down && (
          <Typography variant="caption">Flyt ned</Typography>
        )}
      </div>
    </div>
  );
};

export default memo(FavoritesEditSelectedChannelsRowOrderButtons);
